import { getApiClient } from '@src/shared/types/api-client'
import { MutationFunction, useMutation, useQueryClient } from '@tanstack/react-query'

export interface CleanupRequestDto {
  contains: string
}

export interface CleanupResponseDto {
  deletedCount: number
  message: string
}

const cleanupByContent: MutationFunction<CleanupResponseDto, CleanupRequestDto> = async (dto) => {
  const apiClient = getApiClient()
  const response = await apiClient.post('ExceptionLogs/actions/bulk-delete', dto)
  return response.data as CleanupResponseDto
}

export function useCleanupByContent(): [
  MutationFunction<CleanupResponseDto, CleanupRequestDto>,
  boolean,
  boolean,
  () => void,
] {
  const queryClient = useQueryClient()
  const { mutateAsync, isPending, isError, reset } = useMutation({
    mutationFn: cleanupByContent,
    onSuccess: async (data) => {
      // Invalidate exception lists since we may have deleted some
      await queryClient.invalidateQueries({ queryKey: [{ scope: 'exceptions' }] })
      return data
    },
  })

  return [mutateAsync, isPending, isError, reset]
}